// extracted by mini-css-extract-plugin
module.exports = {"translate_variant":"button_translate_variant___D8xw","simple_variant":"button_simple_variant__0lS72"};